export const NAVIGATION_OPEN_ITEM = "NAVIGATION_OPEN_ITEM";
export const NAVIGATION_CLOSE_ITEM = "NAVIGATION_CLOSE_ITEM";

export const SNACKBAR_SHOW = "SNACKBAR_SHOW";
export const SNACKBAR_HIDE = "SNACKBAR_HIDE";

export const MENU_OPEN = "MENU_OPEN";
export const MENU_CLOSE = "MENU_CLOSE";

export const ASYNC_INDICATOR_SHOW = "ASYNC_INDICATOR_SHOW";
export const ASYNC_INDICATOR_HIDE = "ASYNC_INDICATOR_HIDE";

export const DISPLAY_RESET_PASSWORD = "DISPLAY_RESET_PASSWORD";
export const RESET_TMP_PASSWORD = "RESET_TMP_PASSWORD";

export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAILURE = "AUTH_LOGIN_FAILURE";

export const AUTH_RESET_PASSWORD_SUCCESS = "AUTH_RESET_PASSWORD_SUCCESS";
export const AUTH_RESET_PASSWORD_FAILURE = "AUTH_RESET_PASSWORD_FAILURE";

export const CHANGE_USER_MERCHANT_SUCCESS = "CHANGE_USER_MERCHANT_SUCCESS";

export const GET_USER_MERCHANTS_SUCCESS = "GET_USER_MERCHANTS_SUCCESS";

// -----------------------------------------------------------------------------

export const MERCHANT_COUNTRIES_LOAD_SUCCESS =
  "MERCHANT_COUNTRIES_LOAD_SUCCESS";
export const MERCHANT_RESORTS_LOAD_SUCCESS = "MERCHANT_RESORTS_LOAD_SUCCESS";
export const MERCHANT_LIST_LOAD_SUCCESS = "MERCHANT_LIST_LOAD_SUCCESS";
export const MERCHANT_LIST_SELECT = "MERCHANT_LIST_SELECT";
export const MERCHANT_LIST_SUCCESS = "MERCHANT_LIST_SUCCESS";
export const MERCHANT_LIST_SORT = "MERCHANT_LIST_SORT";
export const MERCHANT_LIST_FILTER = "MERCHANT_LIST_FILTER";
export const MERCHANT_LIST_TOGGLE_FILTERING = "MERCHANT_LIST_TOGGLE_FILTERING";
export const MERCHANT_LIST_CHANGE_PAGE = "MERCHANT_LIST_CHANGE_PAGE";

export const MERCHANT_INFO_SUCCESS = "MERCHANT_INFO_SUCCESS";
export const MERCHANT_INFO_UPDATE_SUCCESS = "MERCHANT_INFO_UPDATE_SUCCESS";

export const MERCHANT_USERS_LOAD_SUCCESS = "MERCHANT_USERS_LOAD_SUCCESS";
export const MERCHANT_USERS_DELETE_SUCCESS = "MERCHANT_USERS_DELETE_SUCCESS";
export const MERCHANT_USERS_EDIT_MODE = "MERCHANT_USERS_EDIT_MODE";
export const MERCHANT_USERS_INPUTS_CHANGE = "MERCHANT_USERS_INPUTS_CHANGE";

export const MERCHANT_PARAMETERS_FETCH_SUCCESS =
  "MERCHANT_PARAMETERS_FETCH_SUCCESS";
export const MERCHANT_PARAMETERS_DELETE_SUCCESS =
  "MERCHANT_PARAMETERS_DELETE_SUCCESS";
export const MERCHANT_PARAMETERS_EDIT_MODE = "MERCHANT_PARAMETERS_EDIT_MODE";
export const MERCHANT_PARAMETERS_SAVE_SUCCESS =
  "MERCHANT_PARAMETERS_SAVE_SUCCESS";
export const MERCHANT_PARAMETERS_INPUTS_CHANGE =
  "MERCHANT_PARAMETERS_INPUTS_CHANGE";
export const MERCHANT_E_TICKET_FETCH_SUCCESS =
  "MERCHANT_E_TICKET_FETCH_SUCCESS";
export const MERCHANT_E_TICKET_SAVE_SUCCESS = "MERCHANT_E_TICKET_SAVE_SUCCESS";
export const MERCHANT_BILLING_SAVE_SUCCESS = "MERCHANT_BILLING_SAVE_SUCCESS";

export const SEARCH_FILTERS_LOAD_SUCCESS = "SEARCH_FILTERS_LOAD_SUCCESS";

export const ORDER_LIST_SELECT = "ORDER_LIST_SELECT";
export const ORDER_LIST_SUCCESS = "ORDER_LIST_SUCCESS";
export const ORDER_LIST_SORT = "ORDER_LIST_SORT";
export const ORDER_LIST_FILTER = "ORDER_LIST_FILTER";
export const ORDER_LIST_TOGGLE_FILTERING = "ORDER_LIST_TOGGLE_FILTERING";
export const ORDER_LIST_CHANGE_PAGE = "ORDER_LIST_CHANGE_PAGE";
export const HOTE_LIST_SUCCESS = "HOTE_LIST_SUCCESS";
export const HOSTNAME_LIST_SUCCESS = "HOSTNAME_LIST_SUCCESS";

export const TRANSACTION_LIST_SELECT = "TRANSACTION_LIST_SELECT";
export const TRANSACTION_LIST_SUCCESS = "TRANSACTION_LIST_SUCCESS";
export const TRANSACTION_LIST_SORT = "TRANSACTION_LIST_SORT";
export const TRANSACTION_LIST_FILTER = "TRANSACTION_LIST_FILTER";
export const TRANSACTION_LIST_TOGGLE_FILTERING =
  "TRANSACTION_LIST_TOGGLE_FILTERING";
export const TRANSACTION_LIST_CHANGE_PAGE = "TRANSACTION_LIST_CHANGE_PAGE";

export const CUSTOMER_LIST_SELECT = "CUSTOMER_LIST_SELECT";
export const CUSTOMER_LIST_SUCCESS = "CUSTOMER_LIST_SUCCESS";
export const CUSTOMER_LIST_SORT = "CUSTOMER_LIST_SORT";
export const CUSTOMER_LIST_FILTER = "CUSTOMER_LIST_FILTER";
export const CUSTOMER_LIST_TOGGLE_FILTERING = "CUSTOMER_LIST_TOGGLE_FILTERING";
export const CUSTOMER_LIST_CHANGE_PAGE = "CUSTOMER_LIST_CHANGE_PAGE";

export const FILTERS_UPDATE_SUCCESS = "FILTERS_UPDATE_SUCCESS";

export const TOS_LOAD_SUCCESS = "TOS_LOAD_SUCCESS";
export const TOS_UPLOAD_PROGRESS = "TOS_UPLOAD_PROGRESS";
export const TOS_UPLOAD_DONE = "TOS_UPLOAD_DONE";

export const CSV_ERRORS = "CSV_ERRORS";

export const CITIES_LOAD_SUCCESS = "CITIES_LOAD_SUCCESS";

export const CLEAR_CONFIG_SUCCESS = "CLEAR_CONFIG_SUCCESS";
export const IMPORT_APIDAE_DATA_SUCCESS = "IMPORT_APIDAE_DATA_SUCCESS";
export const GET_ACCOMODATION_OPTIONS_SUCCESS =
  "GET_ACCOMODATION_OPTIONS_SUCCESS";
export const GET_ACCOMODATION_IMAGES_SUCCESS =
  "GET_ACCOMODATION_IMAGES_SUCCESS";
export const GET_ACCOMODATION_ROOMS_SUCCESS = "GET_ACCOMODATION_ROOMS_SUCCESS";
export const GET_ACCOMODATION_MEALPLANS_SUCCESS =
  "GET_ACCOMODATION_MEALPLANS_SUCCESS";
export const CHANGE_LANG_SUCCESS = "CHANGE_LANG_SUCCESS";

// -----------------------------------------------------------------------------

export const PARTNERSHIP_RESORTS_LOAD_SUCCESS =
  "PARTNERSHIP_RESORTS_LOAD_SUCCESS";
export const PARTNERSHIP_CHANNELS_LOAD_SUCCESS =
  "PARTNERSHIP_CHANNELS_LOAD_SUCCESS";
export const PARTNERSHIP_RESORTS_SELECT = "PARTNERSHIP_RESORTS_SELECT";
export const PARTNERSHIP_PARTNERS_CHANGE = "PARTNERSHIP_PARTNERS_CHANGE";
export const PARTNERSHIP_SELECTION_CHANGE = "PARTNERSHIP_SELECTION_CHANGE";

export const ORDER_LOAD_SUCCESS = "ORDER_LOAD_SUCCESS";
export const ORDER_RESET_STATE_SUCCESS = "ORDER_RESET_STATE_SUCCESS";
export const RESET_ACK_SUCCESS = "RESET_ACK_SUCCESS";

export const CUSTOMER_LOAD_SUCCESS = "CUSTOMER_LOAD_SUCCESS";
export const CUSTOMER_RESET_STATE_SUCCESS = "CUSTOMER_RESET_STATE_SUCCESS";

export const TRANSACTION_LOAD_SUCCESS = "TRANSACTION_LOAD_SUCCESS";
export const TRANSACTION_REFUND_MODAL = "TRANSACTION_REFUND_MODAL";
export const TRANSACTION_REFUND_CHANGE = "TRANSACTION_REFUND_CHANGE";
export const TRANSACTION_CARD_DEBIT_CHANGE = "TRANSACTION_CARD_DEBIT_CHANGE";
export const TRANSACTION_RESET_STATE_SUCCESS =
  "TRANSACTION_RESET_STATE_SUCCESS";

export const STATISTICS_LOAD_SUCCESS = "STATISTICS_LOAD_SUCCESS";
export const STATISTICS_RELOAD_SUCCESS = "STATISTICS_RELOAD_SUCCESS";
export const FILTERS_LOAD_SUCCESS = "FILTERS_LOAD_SUCCESS";
export const FILTERS_LOAD_PENDING = "FILTERS_LOAD_PENDING";
export const FILTERS_INIT_SUCCESS = "FILTERS_INIT_SUCCESS";
export const FILTERS_RESET_SUCCESS = "FILTERS_RESET_SUCCESS";
export const FIELD_CHANGED_SUCCESS = "FIELD_CHANGED_SUCCESS";
export const RANKING_LIST_SORT = "RANKING_LIST_SORT";
export const RANKING_LIST_CHANGE_PAGE = "RANKING_LIST_CHANGE_PAGE";
export const RANKING_LOAD_SUCCESS = "RANKING_LOAD_SUCCESS";

export const QUERIES_LOAD_SUCCESS = "QUERIES_LOAD_SUCCESS";



// WEBPACK FOOTER //
// ./src/actions.js